var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { staticClass: "soma-header", slot: "page-content" }, [
        _c(
          "section",
          { staticClass: "db relative center mw8-4 margin-fix-soma" },
          [
            _c(
              "h1",
              {
                staticClass:
                  "is-navy is-blenny soma-header lh-heading f-page-title center",
              },
              [_vm._v(_vm._s(_vm.page.seo_title))]
            ),
            _vm._v(" "),
            _vm.page.admat_section.is_link_out
              ? _c("div", {}, [
                  _vm.page.admat_section.header_text &&
                  _vm.page.admat_section.link
                    ? _c("a", {
                        staticClass:
                          "db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc",
                        attrs: {
                          href: _vm.page.admat_section.link,
                          target: "_blank",
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.marked(_vm.page.admat_section.header_text)
                          ),
                        },
                      })
                    : _c(
                        "a",
                        {
                          staticClass:
                            "db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc",
                          attrs: {
                            href: "https://outsidelands.shop.musictoday.com/store/",
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.page.admat_section.header_text))]
                      ),
                ])
              : _c(
                  "div",
                  {},
                  [
                    _vm.page.admat_section.header_text &&
                    _vm.page.admat_section.link
                      ? _c("router-link", {
                          staticClass:
                            "db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc",
                          attrs: { to: _vm.page.admat_section.link },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.marked(_vm.page.admat_section.header_text)
                            ),
                          },
                        })
                      : _c(
                          "router-link",
                          {
                            staticClass:
                              "db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc",
                            attrs: { to: "/tickets" },
                          },
                          [_vm._v(_vm._s(_vm.page.admat_section.header_text))]
                        ),
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "db relative pt0 pt4-ns pb4 pointer admat-soma",
                attrs: {
                  href: "/lineup/#/lineup_groupings/soma-tent",
                  title: "Outside Lands 2021 Lineup",
                },
              },
              [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isWindowWidthMobile,
                      expression: "isWindowWidthMobile",
                    },
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: _vm.page.admat_section.mobile_image,
                      expression: "page.admat_section.mobile_image",
                    },
                  ],
                  staticClass: "db dn-ns relative ",
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isWindowWidthMobile,
                      expression: "!isWindowWidthMobile",
                    },
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: _vm.page.admat_section.desktop_image,
                      expression: "page.admat_section.desktop_image",
                    },
                  ],
                  staticClass: "dn db-ns relative  admat-regular",
                }),
              ]
            ),
            _vm._v(" "),
            _c("p", {
              staticClass:
                "f22px padding-ugh is-tablet-regular link-bold lh-copy",
              domProps: { innerHTML: _vm._s(_vm.marked(_vm.page.intro_text)) },
            }),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "db relative center mw6 ph4 btn-primary has-red-bg",
                attrs: { to: _vm.page.lineup_button.link },
              },
              [
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.page.lineup_button.copy) +
                      "\n            "
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pic-left3" }, [
          _c(
            "div",
            {
              directives: [
                { name: "scrollanimation", rawName: "v-scrollanimation" },
              ],
              staticClass: "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
            },
            [
              _c("img", {
                directives: [
                  { name: "scrollanimation", rawName: "v-scrollanimation" },
                ],
                staticClass: "mw21rem icon icon-margin",
                attrs: {
                  src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg",
                },
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  { name: "scrollanimation", rawName: "v-scrollanimation" },
                ],
                staticClass: "mw21rem icon icon-margin",
                attrs: {
                  src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg",
                },
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  { name: "scrollanimation", rawName: "v-scrollanimation" },
                ],
                staticClass: "mw21rem icon-2 icon-margin",
                attrs: {
                  src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pic-right3" }, [
          _c(
            "div",
            {
              directives: [
                { name: "scrollanimation", rawName: "v-scrollanimation" },
              ],
              staticClass: "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
            },
            [
              _c("img", {
                directives: [
                  { name: "scrollanimation", rawName: "v-scrollanimation" },
                ],
                staticClass: "mw21rem icon icon-margin",
                attrs: {
                  src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg",
                },
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  { name: "scrollanimation", rawName: "v-scrollanimation" },
                ],
                staticClass: "mw21rem icon icon-margin",
                attrs: {
                  src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg",
                },
              }),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }